// SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
// Copyright (C) 2024-2025 (original work) Open Assessment Technologies SA
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License

import config from '@/config';
import { getPermissionsGuard } from '@/core/guards/permissionsGuard';

export const routing = [
    {
        path: [config.routes.aiLabs.home],
        guard: getPermissionsGuard([{ resource: 'portal.labs', scopes: ['view'] }]),
        controller: () => import('./controllers/aiLabs')
    },
    {
        path: [config.routes.aiLabs.msWordConversion],
        guard: getPermissionsGuard([{ resource: 'portal.labs', scopes: ['create'] }]),
        controller: () => import('./modules/converters/wordDoc/controllers/wordConversion')
    },
    {
        path: [config.routes.aiLabs.msWordPreview],
        guard: getPermissionsGuard([{ resource: 'portal.labs', scopes: ['view'] }]),
        controller: () => import('./modules/converters/wordDoc/controllers/previewWord')
    },
    {
        path: [config.routes.aiLabs.csvPreview],
        guard: getPermissionsGuard([{ resource: 'portal.labs', scopes: ['view'] }]),
        controller: () => import('./modules/converters/csv/controllers/previewCsv')
    },
    {
        path: [config.routes.aiLabs.csvConversion],
        guard: getPermissionsGuard([{ resource: 'portal.labs', scopes: ['create'] }]),
        controller: () => import('./modules/converters/csv/controllers/csvConversion')
    },
    {
        path: [config.routes.aiLabs.generate],
        guard: getPermissionsGuard([{ resource: 'portal.labs', scopes: ['create', 'edit'] }]),
        controller: () => import('./modules/deliveries/controllers/generateDelivery')
    },
    {
        path: [config.routes.aiLabs.preview],
        guard: getPermissionsGuard([{ resource: 'portal.labs', scopes: ['view'] }]),
        controller: () => import('./modules/deliveries/controllers/previewDelivery')
    },
    {
        path: [config.routes.aiLabs.score],
        guard: getPermissionsGuard([{ resource: 'portal.labs', scopes: ['view'] }]),
        controller: () => import('./modules/scoreSuggestion/controllers/scoreSuggestion')
    },
    {
        path: [config.routes.aiLabs.suggestedScore],
        guard: getPermissionsGuard([{ resource: 'portal.labs', scopes: ['create'] }]),
        controller: () => import('./modules/scoreSuggestion/controllers/previewScore')
    },
    {
        path: [config.routes.aiLabs.documentDelivery],
        guard: getPermissionsGuard([{ resource: 'portal.labs', scopes: ['create'] }]),
        controller: () => import('./modules/deliveries/controllers/documentDelivery')
    },
    {
        path: [config.routes.aiLabs.deliveryDocumented],
        guard: getPermissionsGuard([{ resource: 'portal.labs', scopes: ['view'] }]),
        controller: () => import('./modules/deliveries/controllers/deliveryDocumented')
    }
];
